import React, { ReactNode, useCallback, useContext } from "react";
import { iterate, sortDictionary, useDictinaryFilter } from "./CommonDataMethods";
import { DictionaryEntryType, DictionaryType } from "./types";

type DataLayerProviderProps = {
    initialValue: {
        dataLayer: DictionaryType;
        setDataLayer: (dictionaryData: DictionaryType) => void;
    };
    children: ReactNode | ReactNode[];
};

const dataLayerContext = React.createContext({
    dataLayer: {} as DictionaryType,
    setDataLayer: (dictionaryData: DictionaryType) => { }
});

export function useDataLayerPopulator() {
    const { dataLayer } = useDataLayerContext();
    const filterDictonary = useDictinaryFilter();

    return useCallback((dictionary: Array<DictionaryEntryType>) => {
        let filteredDictionary = filterDictonary(dictionary);

        const sortedDictionary = sortDictionary(filteredDictionary);

        const nextIteration = iterate(sortedDictionary, dataLayer.currentIteration?.iteration || 0);

        return {
            dictionary: sortedDictionary,
            currentIteration: nextIteration,
            tags: dataLayer.tags || [],
            ready: true
        }
    }, [dataLayer.currentIteration?.iteration, dataLayer.tags, filterDictonary]);
}

export function useDataLayerContext() {
    return useContext(dataLayerContext);
}

export default function DataLayerProvider({ children, initialValue }: DataLayerProviderProps) {
    return <dataLayerContext.Provider value={initialValue}>{children}</dataLayerContext.Provider>
}